// Centralized "mindful session" logger. Posts the session to the backend so
// the user's mindful minute counter and per-kind breakdown stay in sync.
// Silently no-ops when the user is not logged in.

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const logMindfulSession = async ({ kind, durationSec, ref }) => {
  try {
    const token = localStorage.getItem('rbr_token');
    if (!token) return null;
    const res = await fetch(`${API_URL}/api/user/mindful-session`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ kind, durationSec, ref }),
    });
    if (!res.ok) return null;
    return await res.json();
  } catch (e) {
    console.warn('mindful-session log failed', e);
    return null;
  }
};

export const formatMindfulTime = (seconds) => {
  const s = Math.max(0, Math.floor(seconds || 0));
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  const mm = m % 60;
  return mm ? `${h}h ${mm}m` : `${h}h`;
};
